import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

import { FlagUsersTab } from "~/features/feature-flags/pages"

/** `q` lets the Companies tab open this tab searched to one company. */
const usersSearchSchema = z.object({
  q: z.string().optional().catch(undefined),
})

export const Route = createFileRoute("/_auth/internal/feature-flags/$flagKey/_layout/users")({
  validateSearch: usersSearchSchema,
  component: FlagUsersTab,
})
